import { render, staticRenderFns } from "./init_data.vue?vue&type=template&id=084c34c4&scoped=true&"
import script from "./init_data.vue?vue&type=script&lang=js&"
export * from "./init_data.vue?vue&type=script&lang=js&"
import style0 from "./init_data.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./init_data.vue?vue&type=style&index=1&id=084c34c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c34c4",
  null
  
)

export default component.exports